<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智能梯控轮播图 -->
    <LadderControlBanner></LadderControlBanner>
    <!-- 智能梯控硬件描述 -->
    <LaddercontrolDescribe></LaddercontrolDescribe>
    <!-- 多种乘梯方式 生活更便捷 -->
    <LadderControl></LadderControl>
    <!-- 智能梯控优势 -->
    <LaddercontrolAdvantage></LaddercontrolAdvantage>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import LadderControlBanner from '../../../../components/pc/Programme/LadderControlComponents/LadderControlBanner.vue'
import LaddercontrolDescribe from '../../../../components/pc/Programme/LadderControlComponents/LaddercontrolDescribe.vue'
import LadderControl from '../../../../components/pc/Programme/LadderControlComponents/LadderControl.vue'
import LaddercontrolAdvantage from '../../../../components/pc/Programme/LadderControlComponents/LaddercontrolAdvantage.vue'

export default {
  setup() {
    return reactive({
      
    });
  },
  components: {
    TopNav,
    ButtonNav,
    LadderControlBanner,
    LaddercontrolDescribe,
    LadderControl,
    LaddercontrolAdvantage,
  },
};
</script>

<style scoped>

</style>
